import { createStore } from "vuex";

// 创建一个新的 store 实例
export const store = createStore({
  state() {
    return {
      articlesData: [],
    };
  },
  mutations: {
    setArticlesData(state, data) {
      state.articlesData = data;
    },
  },
  actions: {
    updateArticlesData({ commit }, data) {
      commit("setArticlesData", data);
    },
  },
});
